import { render } from "./FirstTimer.vue?vue&type=template&id=40c324c1&scoped=true"
import script from "./FirstTimer.vue?vue&type=script&lang=js"
export * from "./FirstTimer.vue?vue&type=script&lang=js"

import "./FirstTimer.vue?vue&type=style&index=0&id=40c324c1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c324c1"]])

export default __exports__